import { Component } from '@angular/core';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { SharedModule } from '@app/shared/shared.module';
import { ContactFormComponent } from '../contact-form/contact-form.component';
import { AdBlock1Component } from '@app/shared/components/ads/ad-block1/ad-block1.component';
import { AdsModule } from '@app/shared/ads.module';

@Component({
	selector: 'app-contact-home',
	standalone: true,
	imports: [
		SharedModule,
		ContactFormComponent,
		AdsModule,
	],
	templateUrl: './contact-home.component.html',
	styleUrl: './contact-home.component.scss'
})
export class ContactHomeComponent {

	constructor (
		private nav: NavigationService,
	) { }

	public goAbout = () => this.nav.goAbout();
	public goRules = () => this.nav.goRules();
	public goRulesCeb = () => this.nav.goRulesCelebrity();

}
